<template>
  <footer class="tw-px-5 tw-py-5 tw-border-t tw-border-t-gray-200 tw-space-x-5">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: 'DialogFooter',
}
</script>
